import React from 'react';
import { GRADE_NAME_LIST, CATEGORY_GENERAL2_NAME_LIST } from '../../../lib/const';
import sanitizeHtml from 'sanitize-html';
import { sanitizeOption } from 'lib/sanitizeHtml';

const BookDetailSpecs = ({ book }) => {

    if (book.isService !== 'Y') {
        return (
            <div className="notice_box">
                <div>
                    <h3>퀴즈 미 제공 도서</h3>
                    <p>독서길라잡이에서 퀴즈를 제공하려면 출판사 및 저자의 허락이 필요합니다.<br />퀴즈 등록시 까지 시간이 걸리며, 특정 출판사 책은 저작권 문제로 제공이 안될 수 있습니다.</p>
                </div>
            </div>
        );
    }

    // 학년을 표시
    function renderGrade() {
        if (undefined === book.grades) return;
        return book.grades.map(grade => GRADE_NAME_LIST[grade.grade]).join(', ');
    }

    //교과연계 표시
    // function renderSchoolBook(){
    //     if( undefined===book.schoolBookCategories ) return;
    //     return book.schoolBookCategories.map(schoolbook=>schoolbook.name).join(', ');
    // }

    // /**
    //  * 키워드 
    //  * @param {*} showKeypoint 핵심 키워드를 표시 여부  false: 일반 키워드만 표시
    //  */
    //  function renderKeyword(showKeypoint)
    // {
    //     if( undefined===book.keywords ) return;
    //     if(showKeypoint){
    //         return book.keywords.filter( (keyword)=>keyword.keypoint==='Y').map(keyword=>keyword.name).join(', ');
    //     }else{
    //         return book.keywords.filter( (keyword)=>keyword.keypoint==='N').map(keyword=>keyword.name).join(', ');
    //     }
    // }


    return (
        <div className="section">
            <div className="category_title">기본정보</div>
            <div className="specs contents">
                <table>
                    <tbody>
                        <tr>
                            <th>분류별 장르</th>
                            <td>{CATEGORY_GENERAL2_NAME_LIST[book.category_general2]}</td>
                        </tr>

                        <tr>
                            <th>권장대상</th>
                            <td>{renderGrade()}</td>
                        </tr>
                        {/* 
                <tr>
                    <th>교과연계</th>
                    <td>{renderSchoolBook()}</td>
                </tr>

            
                <tr>
                    <th>성&emsp;&emsp;향</th>
                    <td>
                        { book.tendency_fun==='Y'?'재미 ':'' }
                        { book.tendency_empathy==='Y'?'공감 ':'' }
                        { book.tendency_knowledge==='Y'?'지식 ':'' }
                        { book.tendency_inquiry==='Y'?'탐구 ':'' }
                    </td>
                </tr>
                */}

                        <tr>
                            <th>수상내역</th>
                            <td className="awards" dangerouslySetInnerHTML={{ __html: sanitizeHtml(book.awards, sanitizeOption) }}></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}
export default BookDetailSpecs;


